import { Checkbox, Dropdown as ConfiguratorDropdown, Popconfirm, Radio, Tooltip } from 'antd';
import { CompanyTheme } from '../../api/types';
import DayjsRangePicker from '../../components/DayjsRangePicker';
import VehicleCarousel from '../../components/Images';
import PaginatedTableWithContext from '../../components/PaginatedTableWithContext';
import TimePicker from '../../components/TimePickerField';
import BasicPageWithHeader from '../../layouts/BasicLayout/BasicPageWithHeader';
import type { ThemeComponents } from '../context';
import Anchor from '../default/Anchor';
import BackButton from '../default/BackButton';
import Calculator from '../default/Calculator';
import CardWithHeader from '../default/CardWithHeader';
import CloseButton from '../default/CloseButton';
import ComparisonButton from '../default/ComparisonButton';
import ConfiguratorDepositDisplay from '../default/Configurator/DepositDisplay';
import ConfiguratorMessageButton from '../default/Configurator/MessageButton';
import ConfiguratorSubHeader from '../default/Configurator/SubHeader';
import ConsentModal from '../default/ConsentModal';
import Dropdown from '../default/Dropdown';
import ErrorMessageBox from '../default/ErrorMessageBox';
import InfoMessageBox from '../default/InfoMessageBox';
import Input from '../default/Input';
import JourneySteps from '../default/JourneySteps';
import ListItem from '../default/ListItem';
import LoadingSpinner from '../default/LoadingSpinner';
import Modal from '../default/Modal';
import notification from '../default/notification';
import Search from '../default/Search';
import Select from '../default/Select';
import Steps from '../default/Steps';
import Tabs from '../default/Tabs';
import Title from '../default/Title';
import WarningMessageBox from '../default/WarningMessageBox';
import makeThemeComponents from '../makeThemeComponents';
import PorscheCarousel from '../porsche/Carousel';
import AdminGlobalStyles from './AdminGlobalStyles';
import ArrowDownIcon from './ArrowDownIcon';
import Button from './Button';
import LegalText from './ConsentsAndDeclarations/LegalText';
import FormFields from './Fields/FormFields';
import PageWithHeader from './PageWithHeader';

const AdminTheme: ThemeComponents = {
    theme: CompanyTheme.Admin,
    gutter: {
        testDriveModal: [14, 14],
    },
    Dropdown,
    ConfiguratorDropdown,
    Select,
    Button,
    BackButton,
    CloseButton,
    ComparisonButton,
    Input,
    ConfiguratorSubHeader,
    ConfiguratorDepositDisplay,
    ConfiguratorMessageButton,
    PageWithHeader,
    StandardLayout: BasicPageWithHeader,
    ConfiguratorLayout: BasicPageWithHeader,
    MobilityWebpageLayout: BasicPageWithHeader,
    FinderLayout: BasicPageWithHeader,
    Title,
    Checkbox,
    CheckboxGroup: Checkbox.Group,
    RangePicker: DayjsRangePicker,
    TimePicker,
    FormFields,
    LoadingSpinner,
    Modal,
    ConsentModal,
    notification,
    Radio,
    RadioGroup: Radio.Group,
    CardWithHeader,
    Steps,
    Search,
    ErrorMessageBox,
    WarningMessageBox,
    InfoMessageBox,
    JourneySteps,
    PaginatedTableWithContext,
    Popconfirm,
    Carousel: PorscheCarousel,
    Tooltip,
    Calculator,
    ListItem,
    Tabs,
    Anchor,
    LegalText,
    ArrowDownIcon,
    VehicleCarousel,
};

export default makeThemeComponents('AdminThemeProvider', AdminTheme, AdminGlobalStyles);
